const dreamcontact=()=>{
     const handleEvent = (plan) => {
  // Format WhatsApp message
  const message = `I am interested want more infomation on this`;

  const url = `https://wa.me/918700364602?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};
    return(
        <>
            <div className="container-fluid" style={{background: "linear-gradient(to right, #3e13c0ff ,  #426fecff)", borderBottom:'2px solid #ffffff'}}>
                <div className="container servicesContent" style={{padding:'50px'}}>
                    <div className="row">
                        <div className="col-md-8">
                            <h2 style={{color:'#ffffff', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>Ready to build your website or mobile application solution?</h2>
                            <p style={{color:'#ffffff'}}>Send us your requirement on info@akcoda.in or call +91-8851042421</p>
                        </div>
                        <div className="col-md-4 d-flex justify-content-center align-items-center">
                            <div>
                                <button
                                    className="btns"
                                    onClick={() => handleEvent()}
                                    >   
                                    Contact
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default dreamcontact